const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};

/* Mountain Barracks homepage trust-card links */
(() => {
  const trustLinks = [
    { url: '/pages/shipping-policy', label: 'View shipping policy' },
    { url: '/pages/return-refund-policy', label: 'View return policy' },
    { url: '/cart', label: 'Go to cart and secure checkout' },
    { url: '/pages/contact', label: 'Contact order support' }
  ];

  const addTrustCardStyles = () => {
    if (document.getElementById('mb-trust-link-styles')) return;
    const style = document.createElement('style');
    style.id = 'mb-trust-link-styles';
    style.textContent = `
      .mb-trust-strip__grid > .mb-trust-link {
        cursor: pointer;
        transition: background-color .18s ease;
      }
      .mb-trust-strip__grid > .mb-trust-link:hover {
        background: #f7f2e8;
      }
      .mb-trust-strip__grid > .mb-trust-link:focus-visible {
        outline: 3px solid #c86f32;
        outline-offset: -3px;
      }
    `;
    document.head.appendChild(style);
  };

  const initTrustLinks = () => {
    const cards = document.querySelectorAll('.mb-trust-strip__grid > div');
    if (!cards.length) return;

    addTrustCardStyles();

    cards.forEach((card, index) => {
      const link = trustLinks[index];
      if (!link || card.dataset.mbTrustLinked === 'true') return;

      card.dataset.mbTrustLinked = 'true';
      card.classList.add('mb-trust-link');
      card.setAttribute('role', 'link');
      card.setAttribute('tabindex', '0');
      card.setAttribute('aria-label', link.label);

      const openLink = () => {
        window.location.href = link.url;
      };

      card.addEventListener('click', openLink);
      card.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openLink();
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTrustLinks, { once: true });
  } else {
    initTrustLinks();
  }

  document.addEventListener('shopify:section:load', initTrustLinks);
})();
